<!-- Saving Indicator -->
<div *ngIf="saving">
	<div class="spinner-overlay"></div>
	<div class="spinner-content">
		<app-spinner></app-spinner>
	</div>
</div>

<div class="slate full-width full-height">
	<div class="main-flex">
		<!-- Loading Indicator -->
		<app-spinner *ngIf="loading"></app-spinner>

		<!-- Header -->
		<app-page-header [iconId]="157">Return Mail Batch</app-page-header>

		<!-- Container -->
		<div class="main-container">
			<!-- Left Side -->
			<mat-card class="left-side">
				<div>
					<form [formGroup]="returnMailBatchForm">
						<mat-form-field>
							<mat-label>Barcode</mat-label>
							<input
								id="return-mail-batch-barcode-input"
								matInput
								formControlName="identificationBarcode"
								type="text"
								maxlength="16"
							/>
						</mat-form-field>

						<mat-form-field>
							<mat-label>Returned Date</mat-label>
							<input
								id="return-mail-batch-return-date-input"
								matInput
								[matDatepicker]="returnedDatePicker"
								formControlName="returnedDate"
								[max]="maxReturnedDate"
							/>
							<mat-datepicker-toggle matSuffix [for]="returnedDatePicker"></mat-datepicker-toggle>
							<mat-datepicker #returnedDatePicker></mat-datepicker>
						</mat-form-field>

						<mat-form-field>
							<mat-label>Postmarked Date</mat-label>
							<input
								id="return-mail-batch-postmarked-date-input"
								matInput
								[matDatepicker]="postmarkedDatePicker"
								formControlName="postmarkedDate"
								[max]="maxPostmarkedDate"
							/>
							<mat-datepicker-toggle matSuffix [for]="postmarkedDatePicker"></mat-datepicker-toggle>
							<mat-datepicker #postmarkedDatePicker></mat-datepicker>
						</mat-form-field>

						<mat-form-field>
							<mat-label>Reason</mat-label>
							<mat-select formControlName="returnMailReasonId">
								<mat-option
									*ngFor="let reason of returnMailReasons"
									[value]="reason.returnMailReasonId"
								>
									{{ reason.description }}
								</mat-option>
							</mat-select>
						</mat-form-field>
					</form>
					<div *ngIf="validationResults" class="validation-results">
						<div class="header">Results</div>
						<table id="return-mail-batch-left-table" style="margin-top: 20px">
							<tr id="return-mail-batch-left-table-valid-barcodes">
								<td id="return-mail-batch-left-table-valid-barcodes-0">Valid Barcodes:</td>
								<td id="return-mail-batch-left-table-valid-barcodes-1">
									<strong>{{ validationResults.validBarcodeCount }}</strong>
								</td>
							</tr>
							<tr id="return-mail-batch-left-table-invalid-barcodes">
								<td id="return-mail-batch-left-table-invalid-barcodes-0">Invalid Barcodes:</td>
								<td id="return-mail-batch-left-table-invalid-barcodes-1">
									<strong>{{ validationResults.invalidBarcodeCount }}</strong>
								</td>
							</tr>
							<tr id="return-mail-batch-left-table-returned-mail">
								<td id="return-mail-batch-left-table-returned-mail-0">Already Returned:</td>
								<td id="return-mail-batch-left-table-returned-mail-1">
									<strong>{{ validationResults.returnedMailCount }}</strong>
								</td>
							</tr>
						</table>
						<app-progress-button
							(click)="processReturns()"
							[buttonText]="'Process Returns'"
							[disabled]="saving"
						></app-progress-button>
					</div>
				</div>
			</mat-card>

			<!-- Right Side -->
			<div class="right-side">
				<!-- Action Buttons -->
				<div class="action-buttons">
					<button
						[disabled]="returnMailList.length == 0"
						id="validate"
						mat-raised-button
						class="action-button"
						(click)="validate()"
					>
						<fa-icon [icon]="$any(['fass', 'check'])" class="mr-sm"></fa-icon>
						Validate
					</button>
				</div>
				<table
					id="return-mail-batch-right-table"
					mat-table
					[dataSource]="returnMailList"
					class="mat-elevation-z2 full-width"
				>
					<ng-container matColumnDef="identificationBarcode">
						<th id="return-mail-batch-right-table-barcode" mat-header-cell *matHeaderCellDef>Barcode</th>
						<td
							id="return-mail-batch-right-table-barcode-{{ i }}"
							mat-cell
							*matCellDef="let element; let i = index"
						>
							{{ element.identificationBarcode }}
						</td>
					</ng-container>

					<ng-container matColumnDef="returnedDate">
						<th id="return-mail-batch-right-table-returned-date" mat-header-cell *matHeaderCellDef>
							Return Date
						</th>
						<td
							id="return-mail-batch-right-table-returned-date-{{ i }}"
							mat-cell
							*matCellDef="let element; let i = index"
						>
							{{ element.returnedDate | date: 'MM/dd/yyyy' }}
						</td>
					</ng-container>

					<ng-container matColumnDef="postmarkedDate">
						<th id="return-mail-batch-right-table-postmarked-date" mat-header-cell *matHeaderCellDef>
							Postmarked Date
						</th>
						<td
							id="return-mail-batch-right-table-postmarked-date-{{ i }}"
							mat-cell
							*matCellDef="let element; let i = index"
						>
							{{ element.postmarkedDate | date: 'MM/dd/yyyy' }}
						</td>
					</ng-container>

					<ng-container matColumnDef="returnMailReasonId">
						<th id="return-mail-batch-right-table-return-reason" mat-header-cell *matHeaderCellDef>
							Reason
						</th>
						<td
							id="return-mail-batch-right-table-return-reason-{{ i }}"
							mat-cell
							*matCellDef="let element; let i = index"
						>
							{{ getReturnMailReasonFromId(element.returnMailReasonId).description }}
						</td>
					</ng-container>

					<ng-container matColumnDef="letterId">
						<th id="return-mail-batch-right-table-letterId" mat-header-cell *matHeaderCellDef></th>
						<td
							id="return-mail-batch-right-table-letterId-{{ i }}"
							mat-cell
							*matCellDef="let element; let i = index"
							[ngStyle]="{ width: '32px' }"
						>
							<app-db-icon
								*ngIf="element.letterId === null"
								[iconId]="521"
								[fixedWidth]="true"
								style="font-size: 16pt"
							>
							</app-db-icon>
						</td>
					</ng-container>

					<ng-container matColumnDef="returnedStatus">
						<th id="return-mail-batch-right-table-status" mat-header-cell *matHeaderCellDef>
							Returned Status
						</th>
						<td
							id="return-mail-batch-right-table-status-{{ i }}"
							mat-cell
							*matCellDef="let element; let i = index"
						>
							{{ element.isReturned ? 'Returned' : '' }}
						</td>
					</ng-container>

					<tr
						id="return-mail-batch-right-table-header"
						mat-header-row
						*matHeaderRowDef="displayedColumns"
					></tr>
					<tr
						id="return-mail-batch-right-table-row-{{ i }}"
						mat-row
						*matRowDef="let row; columns: displayedColumns; let i = index"
					></tr>
				</table>
			</div>
		</div>
	</div>
</div>
